import React, {useEffect, useMemo, useRef, useState} from 'react';
import styles from './ConfirmDialog.module.css';
import useFocusTrap from '../../app-shell/useFocusTrap';
import TextInput from '../form/TextInput';

// A small dialog for renaming a single item - reuses the ConfirmDialog shell
// with a TextInput in place of the body text.
const RenameDialog = ({open, initialValue, label = 'Name', onSave, onCancel, busy}) => {
    const [value, setValue] = useState(initialValue || '');
    const dialogRef = useRef(null);
    const inputRef = useRef(null);
    const initialFocusRefs = useMemo(() => [inputRef], []);

    useFocusTrap(open, dialogRef, initialFocusRefs);

    useEffect(() => {
        if (open) setValue(initialValue || '');
    }, [open, initialValue]);

    if (!open) return null;

    const trimmed = value.trim();

    return (
        <div className={styles.scrim} onClick={onCancel}>
            <div
                ref={dialogRef}
                role="dialog"
                aria-modal="true"
                aria-labelledby="rename-dialog-title"
                className={styles.dialog}
                onClick={(e) => e.stopPropagation()}
                onKeyDown={(e) => {
                    if (e.key === 'Escape') onCancel();
                    if (e.key === 'Enter' && trimmed) onSave(trimmed);
                }}
            >
                <h3 id="rename-dialog-title" className={styles.title}>Rename</h3>
                <TextInput
                    id="rename-value"
                    label={label}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    ref={inputRef}
                />
                <div className={styles.actions}>
                    <button type="button" className={styles.cancelButton} onClick={onCancel}>Cancel</button>
                    <button
                        type="button"
                        className={styles.confirmButton}
                        style={{background: 'var(--ov-ink)'}}
                        disabled={busy || !trimmed}
                        onClick={() => onSave(trimmed)}
                    >
                        {busy ? 'Saving…' : 'Save'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RenameDialog;
